import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
// import { selectDragActiveId, selectNow, setDragActiveId, setUpdateActionStamp } from "../../../AppSlice";
// import { PlayoutScheduler } from "../../../helpers/playoutScheduler";
import styles from './Calendar.module.scss';
import { permissions, userCan } from "../../../helpers/permissions";
import { emptyTimelineItem, IDrawEvent, ITimelineItem, TimelimeChannel } from "./Timeline.model";
// import { PanelTypes } from "../../panels/Panels";

interface IProps {
    day: string;
    panelName: "recording";
    items: ITimelineItem[];
    channel: TimelimeChannel;
    selecedChannel: string;
    index: number;
    rowHeight: number;
    contentWidth: number;
    zoom: number[];
    editMode: boolean;
    hoursBeforeDay: number
    hoursAfterDay: number
    TimelineItemComponent: React.FC<any>;
    drawMode: boolean;
    setDrawMode: (val: boolean) => void;
    drawEvent: IDrawEvent;
    dragItemdId: string;
    onDragItem: (item: { id: string, start: string, channel: string }) => void;
    onCreateDrawEvent: (item: IDrawEvent) => void;
    setDrawEvent: (val: IDrawEvent) => void;
    setDragItemId: (id: string) => void;
    onClickFreespace?: (e: React.MouseEvent<HTMLDivElement>) => void;
    selectedDrawChannelIds?: string[];
}

export default function ChannelRow({
    channel,
    panelName,
    day,
    index,
    editMode,
    items,
    drawEvent,
    rowHeight,
    selecedChannel,
    TimelineItemComponent,
    setDrawEvent,
    zoom,
    contentWidth,
    drawMode,
    hoursAfterDay,
    hoursBeforeDay,
    dragItemdId,
    setDragItemId,
    onClickFreespace,
    onCreateDrawEvent,
    setDrawMode,
    onDragItem,
    selectedDrawChannelIds = [],
}: IProps) {

    const dispatch = useAppDispatch()

    // const items = [] // useAppSelector(selectCalendarItems)
    // const editedItems = useAppSelector(selecteditedPopoutItems)
    // const editMode = useAppSelector(selectEditMode)
    // const zoom = useAppSelector(selectZoom)
    // const selecedCalItemId = useAppSelector(selectSelectedCalItemId)
    // const dragCalItemId = useAppSelector(selectDragItemId)
    // const showDetailsItemId = useAppSelector(selectShowDetailsItemId)
    // const zoomFactor = useAppSelector(selectZoomFactor)
    // const playlists = useAppSelector(selectPlaylists)
    // const dragActiveId = useAppSelector(selectDragActiveId)
    // const [nowPosition, setNowPosition] = useState(0)
    const contentRef = useRef(null)
    // const now = useAppSelector(selectNow)
    const [nowPosition, setNowPosition] = useState(0)
    // const [nowPosition, setNowPosition] = useState(0)
    // const newEvent = editedItems["new_0"] //(item => item.id === "0")
    // const drawMode = useAppSelector(selectDrawMode)
    // const drawEvent = useAppSelector(selectDrawEvent)
    // const popoutEditItems = useAppSelector(selecteditedPopoutItems)
    // const hoursBeforeDay = useAppSelector(selectHoursBeforeDay)
    // const hoursAfterDay = useAppSelector(selectHoursAfterDay)
    // const nowPosition = useAppSelector(selectNowPosition)
    // const duplicateMode = useAppSelector(selectDuplicateMode)

    const calcStartPerc = () => {

        let c = (moment.utc(moment.utc().local().format("YYYY-MM-DD HH:mm:ss")).unix() - moment.utc(day).startOf("day").subtract(hoursBeforeDay, 'hours').unix()) / (60 * 60 * (24 + hoursAfterDay + hoursBeforeDay)) * 100
        if (c > 100) return null
        return c
    }

    useEffect(() => {
        const updateNowPosition = () => {
            const pos = calcStartPerc();
            if (pos !== null && pos !== undefined) {
                setNowPosition(pos);
            } else {
                setNowPosition(0);
            }
        };

        updateNowPosition();
        const intervalId = window.setInterval(updateNowPosition, 10000);

        return () => window.clearInterval(intervalId);
    }, [day, hoursAfterDay, hoursBeforeDay]);

    const handleDown = (id) => {
        window['clickInItem'] = true
        // if (editMode && userCan("scheduler", permissions.scheduler.can_edit_existing_schedule.id)) {
            // let itemStatus = items.find(item => item?.id === id)?.status
            // if (itemStatus !== "2" && itemStatus !== "3" && editMode && userCan("scheduler", permissions.scheduler.can_edit_existing_schedule.id)) {
                setDragItemId(id)
        //     }
        // }
    }

    const rect = contentRef.current?.getBoundingClientRect()

    const getPositionTime = e => {
        let perc = (e.clientX - rect.x) / rect.width * 100
        let start = moment.utc(day).subtract(hoursBeforeDay, 'hours').unix() + (60 * 60 * (24 + hoursBeforeDay + hoursAfterDay) * perc / 100) - 1000
        start = moment(moment.unix(start).utc().format("YYYY-MM-DD HH:mm:ss")).unix()
        return start
    }

    const onRowMouseDown = e => {
        if (drawMode) {
            let currect = getPositionTime(e)
            if (currect) {
                currect = getSnapRange(currect)
                const nextChannelIds = selectedDrawChannelIds.length > 0
                    ? selectedDrawChannelIds
                    : [channel?.id];
                setDrawEvent({
                    ...drawEvent,
                    startTime: moment.unix(currect).toISOString(),
                    endTime: moment.unix(currect).toISOString(),
                    channel: channel?.id,
                    channelIds: nextChannelIds,
                })
            }
        }
    }


    const getSnapRange = currect => {
        let sn = drawEvent?.snapValue * 60 * 3
        return Math.ceil(currect / sn) * sn
    }

    const onRowMouseUp = e => {
        if (drawMode) {
            let currect = getPositionTime(e)
            if (currect) {
                currect = getSnapRange(currect)
                let newItem = { ...drawEvent, endTime: moment.unix(currect).toISOString() }
                setDrawEvent(newItem)
                onCreateDrawEvent(newItem)
            }
            setDrawMode(false)
            // dispatch(setUpdateActionStamp())
        }
    }

    const handleMove = (e) => {
        // console.log(dragItemdId, e.movementX);

        if (dragItemdId && e.movementX) {
            let currect = getPositionTime(e)
            if (currect) {
                onDragItem({ id: dragItemdId, start: moment.unix(currect).toISOString(), channel: channel?.id })
            }
        }

        if (drawMode && drawEvent?.startTime) {
            let currect = getPositionTime(e)
            if (currect) {
                currect = getSnapRange(currect)
                setDrawEvent({ ...drawEvent, endTime: moment.unix(currect).toISOString() })
            }
        }

    }

    {/* background: moment.utc(day).date() === moment.utc(now).date() ? 'rgba(220, 200, 187, 0.5)' : colors.lime */ }
    return (
        <div className={styles.dayRow} onMouseMove={handleMove} style={{ height: rowHeight }}>
            {/* <div className={styles.title} style={{ width: 150 }}>
                <div style={{ width: 150 }}>{channel.data.title}<span className={styles.footer}>{channel.data.service?.toUpperCase()}</span></div>
            </div> */}
            <div className={styles.dayContent} ref={contentRef} style={{ width: `${contentWidth}px`, borderBottom: "1px dashed #888" }}>
                {/* { (index + 1)  % 8 === 0 ? <CalendarTimesRow />: null} */}
                <div className={styles.tableDiv}>
                    <table style={{ height: rowHeight }}>
                        <tr >
                            {Array.from(Array(24 + hoursBeforeDay + hoursAfterDay)).map((i, index) => <td key={index} style={{ width: `${100 / (24 + hoursBeforeDay + hoursAfterDay)}%`, backgroundColor: channel?.channelType ? (index < hoursBeforeDay || index >= 24 + hoursBeforeDay ? "#444" : "") : '#444' }}></td>)}
                        </tr>
                    </table>
                </div>
                <div className={styles.dayItems} style={{ height: rowHeight }} onMouseDown={onRowMouseDown} onMouseUp={onRowMouseUp} onDoubleClick={onClickFreespace}>
                    {items?.filter(item => item?.channel === channel.id)?.map((item, i) => <TimelineItemComponent rowHeight={rowHeight} key={'channelitem' + item.id + i} item={item} day={day} hoursBeforeDay={hoursBeforeDay} hoursAfterDay={hoursAfterDay} onMouseDown={handleDown} />)}
                    {(drawEvent?.channelIds?.includes(channel.id) || drawEvent?.channel === channel.id) ? <TimelineItemComponent key={'timelineitem_drawevent'+ panelName + channel.id} rowHeight={rowHeight} item={{ ...emptyTimelineItem, start: drawEvent.startTime, channel: channel.id, length: moment(drawEvent.endTime).unix() - moment(drawEvent.startTime).unix() }} day={day} hoursBeforeDay={hoursBeforeDay} hoursAfterDay={hoursAfterDay} onMouseDown={handleDown} /> : null}
                    {/* {items?.filter(item => item?.backupChannel === channel.resourceId)?.filter(item => !Object.keys(popoutEditItems).includes(item?.id))?.map((item, i) => <CalendarItem rowHeight={rowHeight} key={'channelitem_backup' + item.id + i} item={item} isBackup={true} day={day} onMouseDown={handleDown} />)}
                    {Object.values(popoutEditItems).filter(item => item?.channel === channel.resourceId).map((item, i) => <CalendarItem rowHeight={rowHeight} key={'dayitem_popout_' + item.id + i} item={item} day={day} onMouseDown={handleDown} isEdited={true} />)}
                    {Object.values(popoutEditItems).filter(item => item?.backupChannel === channel.resourceId).map((item, i) => <CalendarItem rowHeight={rowHeight} key={'dayitem_backup_popout_' + item.id + i} item={item} day={day} onMouseDown={handleDown} isBackup={true} isEdited={true} />)}
                    {newEvent?.channel === channel.resourceId ? <CalendarItem rowHeight={rowHeight} item={newEvent} day={day} onMouseDown={handleDown} /> : null}
                    {newEvent?.backupChannel === channel.resourceId ? <CalendarItem item={newEvent} rowHeight={rowHeight} day={day} isBackup={true} onMouseDown={handleDown} /> : null}
                     */}
                </div>
                {nowPosition ? <div style={{ width: '1px', height: rowHeight + 10, border: '1px solid red', top: '-5px', left: `${nowPosition}%`, zIndex: 150, position: 'absolute' }} /> : null}
            </div>
        </div>
    )
}
